import type { BaseMicrositeData } from '../../../contexts/franchise/microsite-context';

const useServiceTypeBlockFilter = (data: BaseMicrositeData, focusedType: string): Record<string, unknown> => {
    const bannedServiceAnchors = (data?.franchise?.bannedInternalLinks || []).filter(link => link && link.includes('#')).map(link => link && link.split('#')[1]);
    const relevantServices = (data?.franchise?.servicesProvidedFilterable || []).map(x => x.serviceLine).reduce((acc, val) => [...acc, ...val.split(',')], []);
    const fieldName = data[focusedType]?.resolvedSections ? 'resolvedSections' : 'sections';
    let removeNext = false;
    const reparsedData = data[focusedType][fieldName].reduce((acc, val) => {
        if (val.anchor && bannedServiceAnchors.includes(val.anchor.anchor_id)) {
            removeNext = true;
            return acc;
        }
        if (val?.show_below_if) {
            if (!val.show_below_if.linked_service_type) {
                return acc;
            }
            const splitServiceMappings = val.show_below_if.linked_service_type[0].franchise_service_mapping.split(',').map(x => x.trim());

            if (!splitServiceMappings.some(y => relevantServices.includes(y))) {
                removeNext = true;
                return acc;
            }
            return acc;
        }
        if (removeNext) {
            removeNext = false;
            return acc;
        }
        return acc.concat(val);
    }, []);

    return {
        ...data,
        [focusedType]: {
            ...data[focusedType],
            [fieldName]: reparsedData,
        },
    };
};

export default useServiceTypeBlockFilter;
